module.exports = __webpack_public_path__ + "3b31184894467681c189b3b62fc9ab39.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-16.png
// module id = 3175
// module chunks = 0